import styled from 'styled-components';
import { MediumSectionHeader, LongBody } from 'components/Typography';

export const StyledCaptions = styled(LongBody)`
  && {
    margin-bottom: 20px;
    line-height: 18px;
  }
`;
export const StyledSmallSectionHeader = styled(MediumSectionHeader)`
  && {
    line-height: 24px;
    margin-bottom: 20px;
  }
`;
